import { FC } from 'react';
import { Button, Modal, Typography } from 'antd';
import { Col, Row } from '@/shared/ui';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
};

const { Title } = Typography;

export const UnsavedChangesModal: FC<Props> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm && onConfirm();
  };

  return (
    <Modal
      title={
        <Col
          alignItems="flex-start"
          style={{ margin: '10px 0', width: '100%' }}
        >
          <Title level={3} style={{ lineHeight: 1, marginTop: 15 }}>
            Unsaved changes
          </Title>
        </Col>
      }
      destroyOnClose
      width={450}
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      onCancel={onCancel}
    >
      <div style={{ marginTop: 20 }}>
        There are unsaved changes in this proc. <br />
        Are you sure you want to discard changes and continue? <br />
      </div>
      <Row justifyContent="flex-end" style={{ marginTop: 40 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" onClick={handleConfirm}>
          Yes, discard changes and continue
        </Button>
      </Row>
    </Modal>
  );
};
